const images = require.context("../assets/images", true);

module.exports = images;
